class GuestFooterController {
  constructor() {
    this.currentDate = new Date();
  }
}

export default GuestFooterController;



// WEBPACK FOOTER //
// ./src/app/screens/guest/components/guest-footer/guest-footer.controller.js